import { IUser } from 'interface/user';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { alpha, makeStyles } from '@material-ui/core';
import { useAppSelector } from 'hooks/redux';

const useStyles = makeStyles((theme) => ({
  root: {
    pointerEvents: 'none',
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 1,
  },
  container: {
    position: 'absolute',
    '& label': {
      fontSize: 24,
      color: alpha(theme.palette.common.black, 0.2),
      textShadow: theme.shadows[1],
    },
  },
}));

const WaterMark = () => {
  const [direction, setDirection] = useState({
    top: 100,
    left: 100,
  });
  const [isShowing, setIsShowing] = useState(false);
  const container = useRef<HTMLDivElement>();
  const content = useRef<HTMLDivElement>();
  const classes = useStyles();
  const user = useAppSelector<IUser>((store) => store.user);

  const randomPosition = useCallback(() => {
    if (!container.current || !container.current) {
      return;
    }
    setDirection({
      top: Math.floor(Math.random() * (container.current.offsetHeight - content.current.offsetHeight) + 1),
      left: Math.floor(Math.random() * (container.current.offsetWidth - content.current.offsetWidth) + 1),
    });
    setIsShowing(true);
    const timeout = setTimeout(() => {
      setIsShowing(false);
      clearTimeout(timeout);
      const innerTimeout = setTimeout(() => {
        randomPosition();
        clearTimeout(innerTimeout);
      }, 60_000);
    }, 5_000);
  }, []);

  useEffect(() => {
    randomPosition();
  }, [randomPosition]);

  return (
    <div className={classes.root} ref={container}>
      <div
        ref={content}
        className={classes.container}
        style={{
          ...direction,
          visibility: isShowing ? 'visible' : 'hidden',
        }}
      >
        <div className='water-mark-name'>
          <label>{user.name}</label>
        </div>
        <div className='water-mark-cpf'>
          <label>{user.email}</label>
        </div>
      </div>
    </div>
  );
};

export default WaterMark;
